(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("paypalExpressCheckoutConfirmation", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            template: "<div sb-loading class='well'></div>",
            controller: ["checkoutResource", "checkoutService", "messageService", "$state", PayPalExpressCheckoutConfirmationCtrl],
            controllerAs: "vm"
        };
        function PayPalExpressCheckoutConfirmationCtrl(checkoutResource, checkoutService, messageService, $state) {
            checkoutResource.confirmPayPalExpressCheckoutPayment({ token: $state.params["token"], payerId: $state.params["PayerID"] }, function () {
                checkoutService.wizard.isStep3Valid = true;
                $state.go("main.checkout.step4", {}, { location: "replace" });
            }, function (error) {
                messageService.error(error);
                $state.go("main.checkout.step3", {}, { location: "replace" });
            });
        }
    });
}());
